module.exports = __webpack_public_path__ + "img/bg.902a3807.png";